/**
 * App.js
 * ======
 * Main application entry point
 * Example integration of BlockExplorer component
 */

import React from 'react';
import BlockExplorer from './components/BlockExplorer';

// Import PrimeReact styles
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

function App() {
  return (
    <div className="App">
      <BlockExplorer />
    </div>
  );
}

export default App;
